const LUMEN_LOGO_URL = "https://customer-assets.emergentagent.com/job_lumen-initiate/artifacts/9n9soq6w_IMG_5592.jpeg";

export const BrandMark = ({ wrapperClassName = "lumen-sigil", testId, imageTestId }) => {
  return (
    <span className={wrapperClassName} data-testid={testId}>
      <img
        alt=""
        aria-hidden="true"
        className="lumen-logo-mark"
        data-testid={imageTestId}
        src={LUMEN_LOGO_URL}
      />
    </span>
  );
};